module.exports = __webpack_public_path__ + "static/img/38-中国地质大学附属中学1.df98e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/38-中国地质大学附属中学1.png
// module id = YCPi
// module chunks = 0